import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@/app/auth/shared/services/auth.service';
import { LocalStorageService } from '@/app/core/storage/local-storage.service';
import { SharedModule } from '@/app/shared/shared.module';

@Component({
  selector: 'app-invitation',
  standalone: true,
  imports: [SharedModule],
  template: `
    <div class="invitation-processing d-flex justify-content-center align-items-center min-vh-100">
      <div class="text-center">
        <div class="spinner-border text-primary mb-3" role="status">
          <span class="visually-hidden">Processing invitation...</span>
        </div>
        <h4>Processing your invitation...</h4>
        <p class="text-muted">Please wait while we redirect you to the appropriate page.</p>
      </div>
    </div>
  `,
  styles: [
    `
      .invitation-processing {
        background-color: #f8f9fa;
      }
    `,
  ],
})
export class InvitationComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private localStorageService: LocalStorageService
  ) {}

  ngOnInit(): void {
    const invitationId = this.route.snapshot.params['invitationId'];

    if (!invitationId) {
      this.router.navigateByUrl('/');
      return;
    }

    // Store the invitation ID for later use
    this.localStorageService.setItem('pendingInvitationId', invitationId);

    // Check if user is authenticated
    const isAuthenticated = this.authService.isAuthenticated();

    if (isAuthenticated) {
      // User is authenticated, redirect to enterprise page with invitation context
      this.router.navigateByUrl('/account/enterprise?invitation=true');
    } else {
      // User is not authenticated, redirect to registration with invitation context
      this.localStorageService.setItem('redirectAfterLogin', '/account/enterprise?invitation=true');
      this.router.navigateByUrl('/auth/login?invitation=true');
    }
  }
}
